import { createSelector } from '@reduxjs/toolkit';
import selectAccountChannelsMap from './selectAccountChannelsMap';

export default createSelector(selectAccountChannelsMap, (channels) =>
  Object.values(channels).sort((a, b) => a?.name?.localeCompare(b?.name))
);
